import { connectCurrentRefinements } from 'react-instantsearch-dom'
import './ProductFilterV1FiltersCount.scss'

export const ProductFilterV1FiltersCount = connectCurrentRefinements(
  ({ items }) => {
    const filtersLength = items.flatMap(filter =>
      filter.items ? filter.items.map(() => 1) : 1
    ).length

    return (
      <span className="product-filter-v1__filter-count">({filtersLength})</span>
    )
  }
)
